import { Component, OnInit, Input } from '@angular/core';
import { Category } from '../category.model';

@Component({
    selector: 'ef-category-detail',
    templateUrl: './category-detail.component.html',
    styleUrls: ['./category-detail.component.css'],
    standalone: false
})
export class CategoryDetailComponent implements OnInit {
    @Input() public category: Category;
    constructor() {}

    ngOnInit() {}
}
